// removed by extract-text-webpack-plugin
module.exports = {"user":"src-scripts-components-DataTable-Cells-User-__userCell___user","edit":"src-scripts-components-DataTable-Cells-User-__userCell___edit","editing":"src-scripts-components-DataTable-Cells-User-__userCell___editing","pictureContainer":"src-scripts-components-DataTable-Cells-User-__userCell___pictureContainer","name":"src-scripts-components-DataTable-Cells-User-__userCell___name","approve":"src-scripts-components-DataTable-Cells-User-__userCell___approve"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/DataTable/Cells/User/userCell.css
// module id = 2617
// module chunks = 0